// eslint-disable-next-line import/no-unresolved
import { Button } from 'src/components';
import styled, { css } from 'styled-components';

export const FilledButton = styled(Button)`
  border-radius: 6px;
  padding: 10px 26px;
  width: 134px;
  height: 36px;
  background: ${({ theme }) => theme.colors.EvolutivevOkButtonColor};

  font-weight: 700;
  font-size: 14px;
  line-height: 16px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.EvolutivevOkButtonColor};
    opacity: 0.8;
  }

 ${({ isDisabled }) => isDisabled ? css`
    pointer-events: none;
    background-color: ${(props) => props.theme.colors.disableEvolutiveButton};
    color: ${(props) => props.theme.colors.disableEvolutiveTextBtn};
    cursor: not-allowed;
 ` : ''}
`;

export const OutlinedButton = styled(Button)`
  border-radius: 6px;
  padding: 10px 26px;
  width: 134px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.ModalTabInativeBottomColor};

  font-weight: 700;
  font-size: 14px;
  line-height: 16px;

  &:hover {
    color: ${(props) => props.theme.colors.text.default};
  }
`;